<template>
  <div class="role">
    <div class="card-container">
      <div class="card-container mrt16">
        <a-row>
          <a-col :span="12">
            <div class="card-title">
              <span v-if="pageType === 'add'">图片新增</span>
              <span v-else-if="pageType === 'edit'">图片修改</span>
            </div>
          </a-col>
        </a-row>
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-row>
            <a-col :span="24">
              <a-col :span="12">
                <a-form-model-item
                  ref="name" label="图片名称" prop="imgname"
                >
                  <a-input
                    v-model="form.imgname"
                    placeholder="请输入图片名称"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="图片位置" prop="imgposition">
                  <a-select v-model="form.imgposition" placeholder="请选择图片位置">
                    <a-select-option :value="1">
                      首页
                    </a-select-option>
                    <a-select-option :value="2">
                      启动页
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-col :span="12">
                <a-form-model-item label="使用场景" prop="useregion">
                  <a-select v-model="form.useregion" placeholder="请选择使用场景" @change="handleRegin">
                    <a-select-option :value="1">
                      APP端
                    </a-select-option>
                    <a-select-option :value="2">
                      设备端
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="跳转链接" prop="link">
                  <a-input
                    v-model="form.link"
                    placeholder="请输入跳转链接"
                  />
                </a-form-model-item>
              </a-col>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="图片上传" prop="upload">
                <a-upload
                  :action="serveUrl"
                  :headers="headers"
                  list-type="picture-card"
                  :file-list="fileList"
                  @preview="handlePreview"
                  @change="handleChange"
                >
                  <div v-if="fileList.length < 8">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">
                      上传图片
                    </div>
                  </div>
                </a-upload>
                <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                  <img alt="example" style="width: 100%" :src="previewImage">
                </a-modal>
                <div>只能上传jpg/png格式文件，每张大小不超过3M</div>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col v-if="disabled && Number(form.imgposition) !== 1" :span="12">
              <a-form-model-item label="选择区域" prop="choiceregion">
                <a-cascader
                  v-model="form.choiceregion"
                  :options="options"
                  :load-data="loadData"
                  change-on-select
                  :field-names="{
                    label: 'name',
                    value: 'id',
                    children: 'children'
                  }"
                  placeholder="省市区"
                  @change="changeArea"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label=" 账号状态" prop="state">
                <a-radio-group v-model="form.state">
                  <a-radio :value="1">
                    启用
                  </a-radio>
                  <a-radio :value="2">
                    禁用
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col v-if="disabled && Number(form.imgposition) !== 1"></a-col>
            <a-col v-if="form.useregion == 1" :span="12">
              <a-form-model-item label="角色选择" prop="deviceType">
                <a-radio-group v-model="form.deviceType">
                  <a-radio :value="1">
                    运营端
                  </a-radio>
                  <a-radio :value="2">
                    督导端
                  </a-radio>
                  <a-radio :value="3">
                    政府端
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="备注" prop="desc">
                <a-input v-model="form.desc" type="textarea" placeholder="请填写备注" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24" style="text-align: center;">
              <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                <a-button type="primary" @click="onSubmit">
                  提交
                </a-button>
                <a-button style="margin-left: 10px;" @click="resetForm">
                  取消
                </a-button>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
    </div>
  </div>
</template>
<script>
import { save } from '@/api/deviceOrder.js'
import Host from '@/config/apiHost'
import { getAreaList } from '@/api/common'
import { mapGetters } from 'vuex'
import {
  getArea,
  getEstate,
  iconFontComponent
} from '@/components/mixins/mixins.js'
function getBase64 (img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
export default {
  mixins: [getArea, getEstate, iconFontComponent],
  data () {
    return {
      imageUrlList: [],
      disabled: true,
      options: [],
      headers: {
        token: ''
      },
      serveUrl: `${Host.uploadImgHost}/cloud/cus/user/upload`,

      previewVisible: false,
      previewImage: '',
      fileList: [],

      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      other: '',
      form: {
        imgname: '',
        imgposition: undefined,
        useregion: undefined,
        link: '',
        choiceregion: [],
        state: '',
        desc: '',
        deviceType: ''
      },

      rules: {
        imgname: [{ required: true, message: '请输入图片名称', trigger: 'blur' }],
        imgposition: [{ required: true, message: '请选择图片位置', trigger: 'change' }],
        useregion: [{ required: true, message: '请选择使用场景', trigger: 'change' }],
        choiceregion: [{ type: 'array', required: true, message: '请选择使用区域', trigger: 'change' }],
        state: [{ required: true, message: '请选择', trigger: 'change' }],
        deviceType: [{ required: true, message: '请选择角色', trigger: 'change' }],
        upload: [{ required: true, message: '请选择图片', trigger: 'change' }]
      },
      pageType: '',
      rowData: null
    }
  },
  created () {
    this.getEstate()
    this.getArea('', 2, null, true)
    this.headers.token = this.token()
  },
  mounted () {
    const vm = this
    const queryData = vm.$route.query
    vm.pageType = queryData.type
    if (vm.pageType === 'edit') {
      const formData = JSON.parse(queryData.row)
      vm.rowData = formData
      // vm.editHandle()
      vm.handleImg()
      vm.form.imgname = formData.name
      vm.form.imgposition = formData.position
      vm.form.useregion = formData.scene
      vm.form.state = formData.status
      vm.form.desc = formData.remark
      vm.form.deviceType = formData.deviceType
    }
  },
  methods: {
    ...mapGetters(['token']),
    editHandle () {
      const vm = this
      vm.getAreaEdit('', 2).then(res => {
        console.log(res, 'res')
        const queryData = vm.$route.query
        const formData = JSON.parse(queryData.row)
        const newOptions = JSON.parse(JSON.stringify([...vm.options]))
        console.log(newOptions, '555')
        newOptions.forEach(item => {
          if (item.id === formData.provinceId) {
            getAreaList({
              id: item.id,
              layer: 3
            }).then(resp => {
              item.children = resp.result.data
              item.children.forEach(thing => {
                getAreaList({
                  id: thing.id,
                  layer: 4
                }).then(respo => {
                  thing.children = respo.result.data
                  // thing.children.forEach(resChild => {
                  //   getAreaList({
                  //     id: resChild.id,
                  //     layer: 5
                  //   }).then(resChild1 => {
                  //     resChild.children = resChild1.result.data
                  //   })
                  // })
                })
              })
            })
          }
        })
        vm.options = newOptions

        setTimeout(() => {
          vm.form.choiceregion = [formData.provinceId, formData.cityId, formData.areaId, formData.streetId]
        }, 1000)
      })
    },
    handleImg () {
      const queryData = this.$route.query
      const imgData = JSON.parse(queryData.row).imageInfos
      const newImgs = []
      imgData.forEach(item => {
        const imgObj = {}
        imgObj.name = 'image.png'
        imgObj.status = 'done'
        imgObj.uid = item.id
        imgObj.url = item.url
        newImgs.push(imgObj)
      })
      this.fileList = newImgs
    },
    getAreaEdit (id, layer, targetOption) {
      return new Promise((reslove) => {
        getAreaList({
          id: id,
          layer: layer
        }).then(res => {
          console.log(res, '没掉')
          res.result.data.forEach(item => {
            if (layer !== 4) {
              this.$set(item, 'isLeaf', false)
            }
          })
          if (layer === 2) {
            this.options = res.result.data
          } else {
            if (targetOption) {
              this.$set(targetOption, 'children', res.result.data)
            }
          }
          reslove()
        })
      })
    },
    loadData (selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]

      this.getArea(targetOption.id, targetOption.layer + 1, targetOption, true)
    },
    handleRegin (value) {
      value === 2 ? this.disabled = true : this.disabled = false
      // this.disabled = value === 1
      this.form.choiceregion = []
    },
    // 选择区域
    changeArea (areasId) {
      console.log(areasId, 'areasId')
      console.log(this.options, '5')
      if (areasId.length < 4) {
        this.getEstate(areasId)
      }
      //  else if (areasId.length === 4) {
      //   this.getEstate(null, areasId[3])
      // }
    },
    onSubmit () {
      this.$refs.ruleForm.clearValidate('upload')
      this.rules.upload[0].required = false
      if (this.form.useregion === 2) {
        if (this.form.choiceregion.length < 3) {
          this.$message.error('区域必选')
          return false
        }
        this.rules.choiceregion[0].required = false
      }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const imageInfos = []
          if (this.pageType === 'add') {
            this.fileList.forEach(item => {
              if (item.response.code === 0) {
                imageInfos.push(item.response.msg)
              }
            })
          } else {
            this.fileList.forEach(item => {
              if (item.response !== undefined) {
                if (item.response.code === 0) {
                  imageInfos.push(item.response.msg)
                }
              } else {
                imageInfos.push(item.url)
              }
            })
          }

          const parms = {
            name: this.form.imgname,
            position: this.form.imgposition,
            scene: this.form.useregion,
            remark: this.form.desc,
            status: this.form.state,
            jumpUrl: this.form.link,
            deviceType: this.form.deviceType,
            // area: this.form.choiceregion,
            provinceId: this.form.choiceregion[0],
            cityId: this.form.choiceregion[1],
            areaId: this.form.choiceregion[2],
            streetId: this.form.choiceregion[3],

            urls: imageInfos
          }
          if (this.pageType === 'edit') {
            parms.id = this.rowData.id
          }
          save(parms).then(res => {
            if (res.code === 0) {
              if (this.pageType === 'add') {
                this.$message.success('添加成功')
              } else {
                this.$message.success('修改成功')
              }
              this.$router.push('/equipment/maintain',)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
      this.$router.push('/equipment/maintain')
    },
    handleCancel () {
      this.previewVisible = false
    },
    async handlePreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleChange (info) {
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate('upload')
      })
      this.fileList = info.fileList
    }
  }

}
</script>

<style lang="stylus">
.role-modal .ant-modal-footer
  text-align center
.del-modal .ant-btn-primary
  display none
</style>
<style lang="stylus" scoped>
</style>
